import LocationHistory from "../../../jsx/components/Dashboard/LocationHistory/locationhistory";

const LocationHistoryWrapper = () => {
  return <LocationHistory />;
};

export const allowedRoles = [
  _enum.ROUTE_PERSONAS.admin,
  _enum.ROUTE_PERSONAS.underwriter,
  _enum.ROUTE_PERSONAS.collections,
];
export default constore(LocationHistoryWrapper);
